import React, { useState, useEffect, useRef } from "react";
import "../../App.css";

import {BackToIndustryVerticalsButton} from "../layout/BackButton";
import QuickLinksSection from "../products/QuickLinksSection";

function GISDataServicesPage({ handleNavClick }) {
  return (
    <div className="services-detail-page gis-data-page">
      <BackToIndustryVerticalsButton handleNavClick={handleNavClick} />

      {/* Header */}
      <div className="gis-detail-header">
        <div className="section__container">
          <h2 className="section__title">GIS and Data Services</h2>
          <p className="section__intro">
            At GEOTECH, we offer a range of GIS data and remote sensing data services to help our clients with most of their spatial and imagery data.
          </p>
        </div>
      </div>

      {/* GIS Workflow Infographic */}
      <section className="gis-about-section gis-about-section">
        <div className="section__container gis-about-container">
          <div className="gis-about-text gis-about-text">
            <h2>GIS</h2>
            <h3>Urban & Regional Planning</h3>
            <p>
              Our dedication lies in offering Geo Technological support services to the Urban, City, and Municipal Management sectors, playing a key role in the advancement of Smart Cities and systems for managing property taxes.
            </p>
            <p>
              Implementation of GIS part of ITMS – Intelligent Transport Management System for Trivandrum Smart City including Field Survey and Data Collection of the depots, bus routes and bus stops, Integration & Configuration of enterprise GIS Platform.
            </p>
          </div>
          <div className="env-about-image gis-about-image--full">
            <img src="/gis.jpg" alt="GIS Workflow Infographic" />
          </div>
        </div>
      </section>

      {/* Feature Sections */}
      <GISFeatureSection
        title="Disaster Mitigation and Management"
        text="Geotech collaborates with agencies to develop solutions for Disaster risk reduction and early warning systems, thus enhancing community safety."
        list={[
          "Focus on early warning and risk reduction strategies",
          "Provides GIS solutions for disaster monitoring and management"
        ]}
        imgSrc="/gis1.jpg"
        imgAlt="Disaster Mitigation Infographic"
      />
      <GISFeatureSection
        title="FOREST DASHBOARD"
        list={[
          "Creating Forest GeoHub a single point destination for forest department to share updated forest information and data sourced from different sources in a common GIS platform. ",
          "This central hub of all relevant applications featuring diverse workflows that provide an in-depth view of the jurisdiction forest area and enable actionable decisions.",
          "To visualize data on Forest Assets, Plantations, Human-wildlife conflicts, Forest Fires, Types & Covers of Forest, Elephant Mortality and more."
        ]}
        imgSrc="/gis2.jpg"
        imgAlt="Disaster Mitigation Infographic"
      />
      <GISFeatureSection
        title="COASTAL ZONE MANAGEMENT"
        text="Geospatial Laboratories have been set up at Coastal Research facilities to support the creation of programs aimed at managing coastal zones and promoting sustainability initiatives."
        list={[
          "Geospatial Labs at Coastal Research facilities enable advanced mapping and monitoring of coastal zones.",
          "They support program development for coastal management and disaster resilience.",
          "These labs drive sustainability initiatives by integrating geospatial data with conservation efforts."
        ]}
        imgSrc="/gis3.jpg"
        imgAlt="Disaster Mitigation Infographic"
      />

      {/* Quick Links */}
      <QuickLinksSection
        handleNavClick={handleNavClick}
        links={[
          { id: 'information-technology' ,title: 'Information Technology', icon: '/bgs/IT_bg.png' },
          { id: 'environment', title: 'Environment',icon:'/bgs/env.png' },
          { id: 'health', title: 'Health',icon:'/bgs/health.png' },
          { id: 'agriculture', title: 'Agriculture',icon: '/bgs/agriculture.png' },
          { id: 'education-research', title: 'Education & Research',icon:'/bgs/edu.png' }
        ]}
      />
    </div>
  );
}

// Reusable Feature Section for GIS Page
function GISFeatureSection({ title, text, list, imgSrc, imgAlt }) {
  return (
    <section className="gis-feature-section">
      <div className="section__container gis-feature-container">
        <div className="gis-feature-text">
          <h3>{title}</h3>
          <p>{text}</p>
          <ul>
            {list.map((item, i) => <li key={i}>{item}</li>)}
          </ul>
        </div>
        <div className="gis-feature-image">
          <img src={imgSrc} alt={imgAlt} />
        </div>
      </div>
    </section>
  );
}

export default GISDataServicesPage;